<template>
<!-- 客户管理弹框 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="90%"
    @ok="handleOk"
    @cancel="handleCancel"
    :footer="null"
  >
  <customer :isChild="true" @selectClick="selectClick" />
  </a-modal>
</template>

<script>
import customer from '@/views/customerManage/index.vue'
export default {
  name: 'CustmerDialog',
  components: {
    customer
  },
  props: {
    title: {
      type: String,
      default: '选择客户'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  data () {
    return {
      chooseData: ''
    }
  },
  methods: {
    selectClick (data) {
      this.chooseData = data
      this.handleOk()
    },
    handleOk () {
      this.$emit('logSuccess', this.chooseData)
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modelDialog/customerDialog.vue